module.exports = __webpack_public_path__ + "media/assets/images/tour/4a_Tour_3-b5a62c72dd6198a1fc177ecb801fa811.png";